export const details = [
  {
    id: "1",
    title: "Filtered by AI",
    content:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    imageUrl:
      "https://images.unsplash.com/photo-1617722694908-9be1092d1bc2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=443&q=80",
  },
  {
    id: "2",
    title: "Searched by AI",
    content:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    imageUrl:
      "https://images.unsplash.com/photo-1629196617890-d353d025ba0f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    id: "3",
    title: "Ordered by AI",
    content:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    imageUrl:
      "https://images.unsplash.com/photo-1414509613498-f53000d3d2c1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
  },
];

export const productShowcase = [
  {
    id: "1",
    price: "50",
    stock: "In stock now",
    name: "Product 1",
    imageUrl:
      "https://images.unsplash.com/photo-1511556820780-d912e42b4980?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cHJvZHVjdHN8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: "2",
    price: "80",
    stock: "In stock now",
    name: "Product 2",
    imageUrl:
      "https://images.unsplash.com/photo-1567721913486-6585f069b332?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8cHJvZHVjdHN8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: "3",
    price: "30",
    stock: "In stock now",
    name: "Product 3",
    imageUrl:
      "https://images.unsplash.com/photo-1611930022073-b7a4ba5fcccd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8cHJvZHVjdHN8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: "4",
    price: "90",
    stock: "In stock now",
    name: "Product 4",
    imageUrl:
      "https://images.unsplash.com/photo-1560769629-975ec94e6a86?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8cHJvZHVjdHN8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: "5",
    price: "150",
    stock: "In stock now",
    name: "Product 5",
    imageUrl:
      "https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTV8fHByb2R1Y3RzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
];

export const StoriesData = [
  {
    id: "1",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0564/0830/9941/articles/image0_1_cf413d18-9be6-4b04-ad09-22871ec760d6_1000x1000.jpg?v=1636113235",
    title: "Story",
    date: "August 2019",
    footerTitle: "Best Seller All Time",
  },
  {
    id: "2",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0564/0830/9941/articles/Will_Turner_1000x1000.png?v=1632312706",
    title: "Q&A",
    date: "December 2020",
    footerTitle: "Story of trailer 105 man",
  },
  {
    id: "3",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0564/0830/9941/articles/gabesimages_2021_nordarun_001_drone-20-2_1000x1000.jpg?v=1625789442",
    title: "Ambassador",
    date: "February 2021",
    footerTitle: "Everyone, meet La Mote",
  },
  {
    id: "4",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0564/0830/9941/articles/image0_3_1000x1000.jpg?v=1647638584",
    title: "Story",
    date: "July 2021",
    footerTitle: "The Funders",
  },
];
